export default __webpack_public_path__ + "static/IBMPlexSans-SemiBoldItalic-Latin1-ab33fa58a6e7146d03f06b0adbfaa106.woff";